import { render, staticRenderFns } from "./ConversationBotMessage.vue?vue&type=template&id=3b4929de&scoped=true&"
import script from "./ConversationBotMessage.vue?vue&type=script&lang=js&"
export * from "./ConversationBotMessage.vue?vue&type=script&lang=js&"
import style0 from "./ConversationBotMessage.vue?vue&type=style&index=0&id=3b4929de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4929de",
  null
  
)

export default component.exports